export const tableOption = {
  dialogDrag: true,
   border: true,
  indexLabel: "序号",
  height:"calc(100vh - 460px)",
  stripe: false,
  menuAlign: "center",
  align: "center",
  menuType: "text",
  searchShow: true,
  excelBtn: false,
  printBtn: false,
  defaultSort:{
    prop:'bindingDate',
    order:'descending'
  },
  viewBtn: false,
  searchBtn:false,
  emptyBtn:false,
  searchMenuSpan: 24,
  menuWidth:90,
  align:"left",
  column: [
    {
      label: "B卡卡号",
      prop: "cardNo",
      sortable: true,
      search:true,
      minWidth:130,
      overHidden:true,
      searchOrder:1
    },
    {
      label: "车队长",
      prop: "captainName",
      sortable: true,
      search:true,
      minWidth:86,
      overHidden:true,
      searchOrder:4
    },
    {
      label: "手机号",
      prop: "mobile",
      sortable: true,
      search:true,
      minWidth:100,
      overHidden:true,
      searchOrder:5
    },
    {
      label: "身份证号",
      prop: "idCard",
      sortable: true,
      minWidth:160,
      overHidden:true,
    },
    {
      label: "银行卡号",
      prop: "bindingBankNo",
      sortable: true,
      minWidth:160,
      overHidden:true,
    },
    {
      label: "状态",
      prop: "status",
      searchOrder:3,
      search:true,
      sortable: true,
      type:"select",
      props: {
        label: "itemName",
        value: "itemValue",
      },
      dicUrl: '/chain/systemdictionaryitem/listDictionaryItem?dictionary=card_status',
      minWidth:80,
      overHidden:true,
    },
    {
      label: "激活时间",
      prop: "searchDate",
      searchOrder:2,
      sortable: true,
      type:"date",
      searchRange:true,
      search: true,
      hide:true,
      showColumn:false,
      valueFormat: 'yyyy-MM-dd',
    },
    {
      label: "激活时间",
      prop: "bindingDate",
      sortable: true,
      type:"datetime",
      valueFormat: 'yyyy-MM-dd HH:mm:ss',
      minWidth:140,
      overHidden:true,
    },
    
    {
      label: "子卡数量",
      prop: "subCardCount",
      sortable: true,
      minWidth:100,
      overHidden:true,
    },
    {
      label: "运单总数",
      prop: "waybillCount",
      sortable: true,
      minWidth:100,
      overHidden:true,
    },
    {
      label: "已交运单数",
      prop: "giveCardCount",
      minWidth:100,
      overHidden:true,
    },
    {
      label: "待结算金额",
      prop: "unsettledAmount",
      sortable: true,
      minWidth:116,
      overHidden:true,
    },
    {
      label: "已结算金额",
      prop: "settledAmount",
      sortable: true,
      minWidth:116,
      overHidden:true,
    },
    {
      label: "已付款金额",
      prop: "paidAmount",
      sortable: true,
      minWidth:116,
      overHidden:true,
    },
  ],
};
